import React from "react";

const StatsDataTable = ({
  headers,
  metricsData,
  tradeData,
  selectedStrategy,
}) => {
  let newTradeData = selectedStrategy !== null ? tradeData[0].day_wise_pnl : [];
  // console.log("Trade Data ------->",tradeData)

  let totalWinDays =
    selectedStrategy === null ? metricsData[0].totalWinDays : 0;
  let totalLossDays =
    selectedStrategy === null ? metricsData[0].totalLossDays : 0;

  function calculateWinLossDays(newTradeData) {
    newTradeData.forEach((trade) => {
      if (trade.profit > 0) {
        totalWinDays++;
      } else if (trade.profit < 0) {
        totalLossDays++;
      }
    });

    return { totalWinDays, totalLossDays };
  }

  calculateWinLossDays(newTradeData);

  const rows = [
    {
      title: "Total PNL",
      data: metricsData.reduce((acc, item) => {
        return acc + item.totalPNL;
      }, 0),
    },
    {
      title: "Total Win Days",
      data: totalWinDays,
    },
    {
      title: "Total Loss Days",
      data: totalLossDays,
    },
  ];

  return (
    <div className="z-0  animate-reveal transition-all duration-500 ease-in">
      <table className="bg-black border border-gray-700 text-sm w-full relative z-0">
        <thead className="bg-[#0F0F0F] text-sm text-left">
          <tr className="text-white border-b border-gray-800">
            {headers.map((header, index) => (
              <th
                key={index}
                className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="bg-black z-0 border-b last-of-type:border-b-0 border-gray-900 font-medium text-white hover:bg-black/90"
            >
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900`}
              >
                {row.title}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-right ${
                  row.title.toLowerCase().includes("loss")
                    ? "text-rose-500"
                    : row.title.toLowerCase().includes("win")
                    ? "text-green-400"
                    : "text-green-400"
                }`}
              >
                {row.data.toFixed(0)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StatsDataTable;
